/* eslint-disable */

import stickySidebar from  '../components/stickySidebar';
import pageFadeOut from '../components/pageFadeOut'
// import animateInOnceSingle from '../components/animateInOnceSingle';
import animateInOnceSingle from '../components/animateInOnceSingle';
import gsap from 'gsap';

import successPageAnimate from '../components/successPageAnimate.js';


export default {
  init() {

    window.addEventListener('load', () => {
      const firstLoadAni = () => {

        setTimeout( () => {
          gsap.to( '#bgFadeIn' , 0.4 , {
            opacity: 1,
            ease: 'power1.in',
          })

          setTimeout( () => {
            gsap.to( '.app-wrapper' , 0.5 , {
              opacity: 1,
              ease: 'power1.in',
            })
            // successPageAnimate('four-o-four-heading');
            animateInOnceSingle();
          },350);

        },0);
      }

      firstLoadAni();
      // }
    })

    // Form Els - sidebar
    let sidebarForm = {
      wrapper: document.querySelector('.sidebar .form-wrapper'),
      top: document.querySelector('.sidebar .form-content'),
      message: document.querySelector('.sidebar .form-results'),
      success: document.querySelector('.sidebar .form-results .success'),
      failed: document.querySelector('.sidebar .form-results .failed'),
    }

    // Form Els - Pink subscribe
    let pinkNewseltterForm = {
      wrapper: document.querySelector('.pink-newsletter .form-wrapper'),
      top: document.querySelector('.pink-newsletter .form-content'),
      message: document.querySelector('.pink-newsletter .form-results'),
      success: document.querySelector('.pink-newsletter .form-results .success'),
      failed: document.querySelector('.pink-newsletter .form-results .failed'),
    }


    let contentBlock;

    // If content blocker is used within post
    if (document.querySelector('.subscribe-to-read') != null) {
      contentBlock = {
        el: document.querySelector('.subscribe-to-read'),
        postContent: document.querySelector('.post-content-inner'),
        contentEl: document.querySelector('.remaining-content'),
        continueDiv: document.querySelector('.continue-content'),
        tagList: document.querySelector('.post-content-inner .tags-list'),
        // continueDivInner: document.querySelector('.continue-content .inner-continue-content'),
      }

      if (contentBlock.tagList != null) {
        contentBlock.tagList.classList.add('adjust-subscribe-form');
      }

      // Get extra content - remove original
      let content = contentBlock.contentEl.innerHTML;
      contentBlock.contentEl.remove();

      // Create div  - add content - add to the footer
      let footer = document.querySelector('footer');
      let newDiv = document.createElement('div');
      // console.log(content)
      // console.log(content.substring(0, 3));
      // console.log(content.indexOf('<p>'))

      let paragraphTag = content.substring(0, 3);
      // console.log();
      if (paragraphTag.indexOf('<p>') == -1) {
        content = '<p>' + content;
      }

      newDiv.classList.add('remaining-content');
      newDiv.innerHTML = content;
      footer.append(newDiv)

      // Add new el to object
      contentBlock.contentEl = document.querySelector('footer .remaining-content');

      // console.dir(contentBlock.contentEl)
    }

    //console.log(sidebarForm)
    //console.log(pinkNewseltterForm)
    // JavaScript to be fired on the home page

    // Controls fade out - on certain links
    let allAnchors = document.querySelectorAll('a.back-button, .featured-posts a');

    allAnchors.forEach(anchor => {
      anchor.addEventListener('click', pageFadeOut)
    })


    // Heading split text animation
    window.addEventListener('load', () => {
      setTimeout(() => {
        animateInOnceSingle('page-title-anim-single');
      },50);
    })

    // eslint-disable-next-line
    let sidebar = new stickySidebar({
      el: document.querySelector('#content-post'),
      sidebar: document.querySelector('.sidebar-wrapper .social-list'),
      sidebarWrapper: document.querySelector('#content-post .sidebar-wrapper'),
      bottomRow: document.querySelector('#related-posts-heading'),
      intro: document.querySelector('.intro'),
    })

    // Reload button
    let reloadButtons = document.querySelectorAll('.reload-button');

    reloadButtons.forEach(button => {
      button.addEventListener('click', () => {
        window.location.reload();
      })
    })




    // console.log($('.mc-form.sidebar, .mc-form.pink-newsletter-form, .mc-form-2.content-block'))
    /* eslint-disable */
    $('.mc-form.sidebar, .mc-form.pink-newsletter-form, .mc-form-2.content-block').on('submit', function(e) {
      //console.log('SINGLE SUBMITTING');
      e.preventDefault();

      // console.log('single', this)

      let tl = gsap.timeline();
      let formEl;

      //var email = $(this).find('#mc-email').val();
      var email = '';
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      // Determine what form
      if (e.target.classList.contains('sidebar')) {
        email = this.querySelector('#mc-email-1').value;
      } else if (e.target.classList.contains('pink-newsletter-form')) {
        email = this.querySelector('#mc-email').value;
      } else if (e.target.classList.contains('content-block')) {
        email = this.querySelector('#mc-email-3').value;
      }

      //console.log(email);
      //console.log(ajaxurl);

      var form = $( this );
      const campaign2 = $(this).data('campaign');
      const campaign = (urlParams.get('utm_campaign') !== null) ? urlParams.get('utm_campaign') : campaign2;
      const source2 = $(this).data('source');
      const source = (urlParams.get('utm_source') !== null) ? urlParams.get('utm_source') : source2;

        var data = {
          action: 'exsite_mailchimp',
          email: email,
          source: source,
          campaign: campaign,
          form: $( this ).serialize(),
        };

        // contnet blocker - sumbitting style change
        if (form[0].classList.contains('content-block')) {
          form[0].classList.add('submitting-style-one');
        }

        var button_text = form.find('button').html();
        form.find('button').html('Submitting...').prop('disabled', true);


        // $.post(ajaxurl, data, function(response) {
        $.ajax({
          type: 'POST',
          url: ajaxurl,
          data: data,
          timeout: 10000,
          success: function(response) {
            response = $.parseJSON(response);
            // form.find('button').html(button_text).prop('disabled', false);
            //console.log(response);

            // Get form var
            if (e.target.classList.contains('sidebar')) {
              formEl = sidebarForm;
              form.find('button').html(button_text).prop('disabled', false);
            } else if (e.target.classList.contains('pink-newsletter-form')) {
              formEl = pinkNewseltterForm;
              form.find('button').html(button_text).prop('disabled', false);
            }
            else if (e.target.classList.contains('content-block')) {
              formEl = contentBlock;
              form.find('button').html(button_text).prop('disabled', false);
            }


            if(response.result == "error"){
              if (formEl != contentBlock) {
                form.parent().find('.response-message').addClass('error').html(`<p>${response.msg}</p>`);
                form.find('button').html(button_text).prop('disabled', false);
                // form.parent().find('.response-message').addClass('error').html(`<p>Success!</p>`);
                // setTimeout(() => { successPageAnimate() }, 1000)

                return false;
              } else if (formEl == contentBlock) {

                form.parent().find('.response-message').addClass('error').html(response.msg);
                return false;
              }
            }

            if(response.result == "subscribed" || response.result == "resubscribed"){
              fbq('track', 'SubmitApplication', {});
              // fbq('track', 'SubmitApplication', { status: response.result });
              // fbq('trackCustom', 'MailChimpForm', {status: response.result});
              // fbq('track', 'SubmitApplication', {status: response.result});

              if (formEl != contentBlock) {
                // form.parent().find('.response-message').addClass('error').html(`<p>${response.msg}</p>`);
                form.parent().find('.response-message').addClass('error').html(`<p>Success!</p>`);
                setTimeout(() => { successPageAnimate(email) }, 1000);

                return false;
              } else if (formEl == contentBlock) {
                subscriberShowContent(formEl, response.result);
              }
            }

            if (response.result == "success") {
              if (formEl != contentBlock) {
                // form.parent().find('.response-message').addClass('error').html(`<p>${response.msg}</p>`);
                form.parent().find('.response-message').addClass('error').html(`<p>Success!</p>`);
                setTimeout(() => { successPageAnimate(email) }, 1000);

                return false;
              } else if (formEl == contentBlock) {
                console.log('new subs');
                subscriberShowContent(formEl, response.result);
                triggerFbPixelEvent();
              }
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            if(textStatus==="timeout") {
              successPageAnimate(email);
            }
          }
        });

        return false;
    })


    // HIde content blocker message - add new contnet - show it
    function subscriberShowContent(formEl, result) {

      if (formEl == contentBlock) {

        // Fill the content
        formEl.continueDiv.children[0].innerHTML = formEl.contentEl.innerHTML;

        let tl = gsap.timeline();

        // Find paragraph in subscriber content - .remaining-content
        let paragraph = formEl.continueDiv.children[0].querySelector('p');

        // Get that paragraphs margin - annyoing offset when calcuation the height
        let extra = window.getComputedStyle(paragraph);
        extra = extra.marginBottom;
        extra = Number(extra.substr(0, extra.length - 2));


        tl.to(formEl.el.children[0].children[1], {
          duration: 0.6,
          alpha: 0,
          height: formEl.el.children[0].children[1].clientHeight,
          ease: "power.inOut",
          onComplete: () => {
            // Clear inner html
            formEl.el.children[0].children[1].innerHTML = '';

            // Create new h3
            let p = document.createElement('h3');
            p.textContent = 'Success!';

            // Add success class
            formEl.el.children[0].children[1].classList.add('success-display');

            // Add success svg
            formEl.el.children[0].children[1].innerHTML += `<svg version="1.1" id="Layer_1" width="60" height="60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 44 44" style="enable-background:new 0 0 44 44;" xml:space="preserve">
            <style type="text/css">
              .check_dark{fill-rule:evenodd;clip-rule:evenodd;fill:#000;}
            </style>
            <path id="Fill-1" class="check_dark" d="M42.2,13.6c-0.4-0.4-1-0.4-1.4,0c-0.3,0.3-0.3,0.7-0.2,1l0,0c0.9,2.3,1.4,4.8,1.4,7.4
              c0,11-9,20-20,20S2,33,2,22S11,2,22,2c5.7,0,10.8,2.4,14.4,6.1l0,0c0.4,0.4,1,0.3,1.4,0c0.4-0.4,0.4-1,0-1.4l-0.1-0.1
              C33.7,2.5,28.1,0,22,0C9.8,0,0,9.8,0,22s9.8,22,22,22s22-9.8,22-22c0-2.8-0.6-5.5-1.5-8C42.4,13.8,42.4,13.7,42.2,13.6L42.2,13.6z
                M22,27.6l-9.3-9.3C12.5,18.1,12.3,18,12,18c-0.6,0-1,0.4-1,1c0,0.3,0.1,0.5,0.3,0.7l10,10c0.2,0.2,0.4,0.3,0.7,0.3
              c0.3,0,0.5-0.1,0.7-0.3l0,0l16.7-17.5l0,0l1.4-1.5l0,0l2.9-3l0,0C43.9,7.5,44,7.3,44,7c0-0.6-0.4-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l0,0
              L39.7,9l0,0l-1.4,1.5l0,0L22,27.6z"/>
            </svg>
            `;

            // Append new h3
            formEl.el.children[0].children[1].append(p);

          },
        })
        tl.to(formEl.el.children[0].children[1], {
          duration: 0.4,
          ease: "power.inOut",
          height: 'auto',
        })
        tl.to(formEl.el.children[0].children[1], {
          duration: 0.6,
          ease: "power.inOut",
          alpha: 1,
        })
        tl.to(formEl.el, {
          duration: 0.6,
          alpha: 0,
          delay: 1,
          ease: "power.inOut",
          onComplete: () => {
            formEl.el.classList.add('hide-me');
          },
        })
        tl.to(formEl.el, {
          height: 0,
          duration: 0.4,
          ease: "power.inOut",
        },'-=0.4')
        tl.to(formEl.continueDiv, {
          duration: 0.6,
          ease: "power.inOut",
          alpha: 0,
          height: 'auto',
        },'-=0.4')
        tl.to(formEl.continueDiv, {
          ease: "power.inOut",
          duration: 0.6,
          alpha: 1,
          onComplete: () => {
            formEl.continueDiv.classList.add('active');
          },
        })
      }
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js